import { RootState } from '../../store/rootReducer';

export const NotificationCloseSelector = (state: RootState) => state.notificationRenewalClose;
